import { apiService } from "@/_services";
/**
 * Get business for all companies
 * @param { object } companies initial company information
 */
export function getBusinesses(companies) {
  let business = [];
  companies.forEach(function(comp) {
    comp["portfolios"].forEach(function(port) {
      business = business.concat(port["fk_id_business"]);
    });
  });
  let params = {
    method: "GET",
    endpoint: "business",
    query_params: {
      format: "json",
      business: { id: business }
    }
  };
  return apiService.getAll(params);
}
